import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jv',
  templateUrl: './jv.component.html',
  styleUrls: ['./jv.component.scss']
})
export class JvComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
